import Image from "../fragments/Image";
import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

import SpecialText from '../fragments/SpecialText';
import SmartLink from '../fragments/SmartLink';

export default function GetInTouch({ block }) {

    const [blockLoaded, setBlockLoaded] = useState(false);

    useEffect(() => {
        setBlockLoaded(true);
    }, []);

    const introRevealRef = useReveal({ once: true });
    const locationsRevealRef = useReveal({ once: true });

    const text_maximum_width = (block.text_maximum_width ? block.text_maximum_width + 'em' : '21em');

    return (
        <div id={block.section_id} className={`c-page__block c-page__block--get-in-touch`}>
            <div className={`l-grid`}>
                <div className={`l-grid__col l-bottom-section-space c-transition-in`} ref={introRevealRef}>
                    {block.heading &&
                        <h1 className="c-heading c-heading--accent c-get-in-touch__heading">
                            <SpecialText text={block.heading} />
                        </h1>

                    }
                    {block.text &&
                        <p className="c-heading c-get-in-touch__large-text" style={{ maxWidth: text_maximum_width }}>
                            <SpecialText text={block.text} />
                        </p>
                    }
                </div>
            </div>
            <div className={`l-grid l-grid--m-even c-get-in-touch__locations c-transition-in`} ref={locationsRevealRef}>
                <div className="l-grid__col">
                    <div className="c-get-in-touch__hr" />
                </div>
                <div className={`c-get-in-touch__locations__image l-grid__col l-grid__col--m-7-12 l-grid__col--l-6-12`}>
                    {block.img_src &&
                        <Image 
                            src={block.img_src || []} 
                            width={block.img_width} 
                            height={block.img_height} 
                            alt={block.img_alt || ''} 
                        />
                    }
                </div>
                <div className={`c-get-in-touch__locations__list l-grid__col l-grid__col--m-5-12 l-grid__col--l-6-12`}>
                    {block.locations && block.locations.length > 0 &&
                        <>
                            {block.locations.map((location, index) => (
                                <div className="c-get-in-touch__location" key={index}>
                                    {location.text &&
                                        <div className="c-get-in-touch__location__text scope-text scope-text--location" dangerouslySetInnerHTML={{__html:location.text}} />
                                    }
                                    {location.map_url &&
                                        <div className="c-links">
                                            <SmartLink
                                                link={location.map_url} 
                                                className="c-links__link c-links__link--button"
                                            >
                                                <svg viewBox="0 0 22 10"><polygon points="16.93 .91 16.25 1.64 19.33 4.5 0 4.5 0 5.5 19.33 5.5 16.25 8.36 16.93 9.09 21.33 5 16.93 .91" /></svg>
                                                View on map
                                            </SmartLink>
                                        </div>
                                    }
                                </div>
                            ))}
                        </>
                    }
                </div>
            </div>
        </div>
    );
}